import RenderCategoryHeadingIcon from './RenderCategoryHeadingIcon'

function RenderCategoryHeading(props) {
  const { categoryData, forPDF } = props

  return (
    <>
      {forPDF ? (
        <div className='d-flex align-items-center pdf-avoid-break'>
          <div className='d-flex align-items-center'>
            <RenderCategoryHeadingIcon categoryName={categoryData.description}></RenderCategoryHeadingIcon>
            <h2 className='h4 mx-4 mb-0'>{categoryData.description}</h2>
            <span className="fw-bold text-small">({categoryData.count})</span>
          </div>
        </div>
      ) : (
        <div className='d-flex align-items-center justify-content-between p-4'>
          <div className='d-flex align-items-center'>
            <RenderCategoryHeadingIcon categoryName={categoryData.description}></RenderCategoryHeadingIcon>
            <h2 className='h4 mx-4 mb-0'>{categoryData.description}</h2>
          </div>
          <span className="fw-bold text-small">({categoryData.count})</span>
        </div>
      )}
    </>
  )
}

export default RenderCategoryHeading